import { create } from "zustand";
import {
  CANDIDATE_PAGE_TITLES,
  CANDIDATE_MODAL_KEYS,
} from "../constants/constant";

const initialState = {
  view: "table",
  activeModal: CANDIDATE_MODAL_KEYS.NONE,
  selectedCandidates: null,

  selectedRows: [],
  rowSelection: {},

};
export const useCandidateManagementStore = create((set, get) => ({
  ...initialState,
  // ===== View =====
  setView: (newView) => set({ view: newView }),
  // ===== Modal =====
  setActiveModal: (modalKey) => set({ activeModal: modalKey }),
  // ===== Page Title =====
  pageTitle: (candidatesType) => {
    return CANDIDATE_PAGE_TITLES[candidatesType] || "Candidates Management";
  },
  // ===== Selected Position =====
  setSelectedCandidates: (selectedCandidates) => set({ selectedCandidates }),
  clearSelectedCandidates: () => set({ selectedCandidates: null }),
    // ===== Selected Rows =====
  setSelectedRows: (rows) => set({ selectedRows: rows }),

  // ===== Row Selection =====
  setRowSelection: (updater) =>
    set((state) => ({
      rowSelection:
        typeof updater === "function"
          ? updater(state.rowSelection)
          : updater,
    })), clearRowSelection: () => set({ rowSelection: {} }),
}));
